var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "search-form", attrs: { action: "/search", method: "get" } },
    [
      _c(
        "ui-input",
        {
          attrs: {
            large: _vm.adaptive.isDesktop,
            autofocus: _vm.adaptive.isDesktop,
            name: "query",
            placeholder: "Например, блузка женская",
            clearable: ""
          },
          model: {
            value: _vm.query,
            callback: function($$v) {
              _vm.query = $$v
            },
            expression: "query"
          }
        },
        [
          _c(
            "vue-client-only",
            [
              _vm.adaptive.isDesktop
                ? _c("f-sprite-icon", {
                    attrs: {
                      slot: "prepend",
                      "icon-link": _vm.$options.icons.IconSearch.id
                    },
                    slot: "prepend"
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }